var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VSheet',{staticClass:"fill-height pa-8"},[(_vm.events.length)?_c('VCalendar',{attrs:{"events":_vm.events,"weekdays":[1, 2, 3, 4, 5]}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }